import { useState } from 'react';
import { CloneDialog } from '../clone/CloneDialog';
import { uiText } from '../../i18n';
import type { CircleFormState } from '../studio/circle/CircleFieldInput';
export function PhotoCrop({ url, state }: { url: string; state: CircleFormState }) {
  const [draft, setDraft] = useState<Record<string, string> | null>(null);
  const ratio = state.inputs.format;
  const available = ['crop_x', 'crop_y', 'zoom'].every(key => state.form?.fields.some(field => field.key === key));
  if (!available || !ratio || ['auto', 'src'].includes(ratio)) return null;
  const values = draft ?? state.inputs;
  return (
    <>
      <button
        type="button"
        disabled={state.locked}
        onClick={() =>
          setDraft({ crop_x: state.inputs.crop_x ?? '0.5', crop_y: state.inputs.crop_y ?? '0.5', zoom: state.inputs.zoom ?? '1' })
        }
      >
        {uiText('Кадр')}
      </button>
      {draft && (
        <CloneDialog label="Кадрирование" busy={false} onClose={() => setDraft(null)}>
          <div className="photo-crop-sheet">
            <p>{uiText('Двигайте картинку, чтобы выбрать кадр')}</p>
            <div className="photo-crop-frame" style={{ aspectRatio: ratio.replace(':', '/') }}>
              <img
                src={url}
                alt={uiText('Кадр')}
                style={{
                  objectPosition: `${Number(values.crop_x) * 100}% ${Number(values.crop_y) * 100}%`,
                  transform: `scale(${values.zoom})`,
                }}
              />
            </div>
            {(['crop_x', 'crop_y', 'zoom'] as const).map(key => (
              <label key={key}>
                {uiText(key === 'zoom' ? 'Приближение' : key === 'crop_x' ? 'По горизонтали' : 'По вертикали')}
                <input
                  type="range"
                  min={key === 'zoom' ? 1 : 0}
                  max={key === 'zoom' ? 3 : 1}
                  step={0.05}
                  value={draft[key]}
                  onChange={event => setDraft(current => ({ ...current, [key]: event.target.value }))}
                />
              </label>
            ))}
            <button
              type="button"
              onClick={() => {
                state.setInputs(current => ({ ...current, ...draft }));
                setDraft(null);
              }}
            >
              {uiText('Готово')}
            </button>
            <button type="button" onClick={() => setDraft(null)}>
              {uiText('Отмена')}
            </button>
          </div>
        </CloneDialog>
      )}
    </>
  );
}
